// extracted by mini-css-extract-plugin
export default {"scrollable-wrapper":"iO4x1U"};